module.exports = __webpack_public_path__ + "img/claim_example.01add6db.png";